<app-nav-header></app-nav-header>
<div class="wrapper">
    <div class="main">
        <div id="productPage">
            <div class="bannerArea">
                <div class="bannerBox">
                    <span>{{
                        'products.products.' + productKey + '.identity'
                            | translate
                    }}</span>
                    <h1>
                        {{
                            'products.products.' + productKey + '.name'
                                | translate
                        }}
                    </h1>
                    <p>
                        {{
                            'products.products.' + productKey + '.desc'
                                | translate
                        }}
                    </p>
                </div>
            </div>

            <div class="previewArea">
                <div class="previewBox">
                    <div class="titleBox">
                        <h2>
                            {{
                                'products.products.' +
                                    productKey +
                                    '.mainBenefit.title' | translate
                            }}
                        </h2>
                        <p>
                            {{
                                'products.products.' +
                                    productKey +
                                    '.mainBenefit.desc' | translate
                            }}
                        </p>
                    </div>
                    <!-- <div
						class="imgBox"
						*ngIf="showSwiper"
					>
						<swiper
							[speed]="500"
							[loop]="fullPiece?.Img?.length > 1"
							[centeredSlides]="true"
							[observeParents]="true"
							[pagination]="{ el: '.swiper-pagination-preview', clickable: true }"
							[autoplay]="{ delay: 5000, disableOnInteraction: false }"
						>
							<ng-container *ngFor="let src of fullPiece?.Img">
								<ng-template swiperSlide>
									<div>
										<img
											[src]="src"
											[alt]="fullPiece?.Name"
										/>
									</div>
								</ng-template>
							</ng-container>
						</swiper>

						<div class="swiper-pagination-preview"></div>
					</div> -->
                </div>
            </div>

            <div class="advantageArea">
                <div class="advantageBox">
                    <p class="intro">
                        {{
                            'products.advantage'
                                | translate
                                    : {
                                          name:
                                              'products.products.' +
                                                  productKey +
                                                  '.name' | translate
                                      }
                        }}
                    </p>
                    <div class="highlightsBox">
                        <div
                            *ngFor="
                                let highlight of 'products.products.' +
                                    productKey +
                                    '.advantage' | translate
                            "
                            class="highlight">
                            <h3>{{ highlight.title }}</h3>
                            <ul>
                                <li *ngFor="let item of highlight.list">
                                    {{ item }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="featureArea">
                <div class="featureBox">
                    <p class="intro">
                        {{
                            'products.functions'
                                | translate
                                    : {
                                          name:
                                              'products.products.' +
                                                  productKey +
                                                  '.name' | translate
                                      }
                        }}
                    </p>
                    <div class="highlightsBox">
                        <div
                            *ngFor="
                                let highlight of 'products.products.' +
                                    productKey +
                                    '.feature' | translate
                            "
                            class="highlight">
                            <h3>{{ highlight.title }}</h3>
                            <p>{{ highlight.desc }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="moreArea">
                <div class="moreBox">
                    <div class="prompt">
                        <h2>{{ 'products.moreElatedCases' | translate }}</h2>
                        <p>{{ 'products.findOtherProduct' | translate }}</p>
                        &nbsp;
                        <a routerLink="/products">{{
                            'products.clickHere' | translate
                        }}</a>
                    </div>

                    <div
                        class="swiperBox"
                        *ngIf="showSwiper">
                        <swiper
                            [slidesPerView]="perPage"
                            [spaceBetween]="32"
                            [speed]="200"
                            [scrollbar]="{
                                el: '.swiper-scrollbar',
                                hide: false
                            }"
                            [navigation]="{
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev'
                            }"
                            [observeParents]="true">
                            <ng-container
                                *ngFor="
                                    let topic of relatedPieces;
                                    let index = index
                                ">
                                <ng-template swiperSlide>
                                    <div
                                        class="info-card"
                                        [ngClass]="{
                                            'info-card': true,
                                            'info-card-even': index % 2 === 0,
                                            'info-card-odd': index % 2 !== 0
                                        }"
                                        (click)="goToSuccess(topic?.NameEN)">
                                        <div class="vital">
                                            <p class="date">
                                                {{ topic?.Date }}
                                            </p>
                                            <!-- <p class="type">
                                                <span>
                                                    {{
                                                        getTranslatedTypeParts(
                                                            topic?.NameEN,
                                                            'before'
                                                        )
                                                    }}
                                                </span>
                                                ｜
                                                {{
                                                    getTranslatedTypeParts(
                                                        topic?.NameEN,
                                                        'after'
                                                    )
                                                }}
                                            </p> -->
                                            <h3 class="content">
                                                {{
                                                    'solutions.explore.successCases.' +
                                                        getSuccessKeyFromNameEN(
                                                            topic?.NameEN
                                                        ) +
                                                        '.name' | translate
                                                }}
                                            </h3>
                                            <div class="tagBox">
                                                <p>
                                                    {{ ('solutions.explore.successCases.' + getSuccessKeyFromNameEN(topic?.NameEN) + '.tags' | translate)?.join?.('，') }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-container>
                        </swiper>
                        <div
                            class="swiper-btm"
                            [ngStyle]="
                                this.relatedPieces.length > this.perPage
                                    ? { display: 'flex' }
                                    : { display: 'none' }
                            ">
                            <div class="scroll">
                                <div class="swiper-scrollbar"></div>
                            </div>
                            <div class="action">
                                <button
                                    class="swiper-button-prev"
                                    aria-label="前一頁"></button>
                                {{ swiperPageRef }}
                                <button
                                    class="swiper-button-next"
                                    aria-label="下一頁"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="faqArea">
                <div class="faqBox">
                    <p class="prompt">FAQs</p>
                    <div class="faqAccordionBox">
                        <p-accordion [activeIndex]="0">
                            <ng-container
                                *ngFor="
                                    let faq of 'products.products.' +
                                        productKey +
                                        '.faq' | translate
                                ">
                                <p-accordionTab [header]="faq.title">
                                    <p>{{ faq.content }}</p>
                                </p-accordionTab>
                            </ng-container>
                        </p-accordion>
                    </div>
                </div>
            </div>

            <app-partnership></app-partnership>
        </div>
    </div>
</div>
<app-footer></app-footer>
